module.exports = __webpack_public_path__ + "img/Character_Kaeya_Thumb.2eb14afa.png";